<template>
  <div id="app" class="bag_cover">
    <div
      class="up"
      @click.stop="
        step--;
        on();
      "
      v-show="step > 0"
    >
      <!-- <button class="prev-btn"></button> -->
      <img class="prev-btn" src="@/assets/image/works/up.png" alt="" />
    </div>
    <div
      class="bottom"
      v-show="step < photo_data.length - 1"
      @click.stop="
        step++;
        on();
      "
    >
      <!-- <button class="next-btn"></button> -->
      <img class="next-btn" src="@/assets/image/works/down.png" alt="" />
    </div>

    <div class="page">
      <Loading :loading_bool="loading_bool"></Loading>
    </div>

    <div v-if="!loading_bool && photo_data">
      <!-- 滚屏事件 -->
      <div
        class="page"
        v-for="(item, index) in photo_data"
        :key="index"
        :style="'top:' + (index - step) * 100 + 'vh'"
      >
        <div class="page_center _width">
          <img :src="item.coverUrl" alt="" class="bag_img fade_image_out" />
          <div class="mose_bag _width">
            <!-- 返回上一页 -->
            <div class="go_home" @click.stop="back()">
              <!-- <img src="@/assets/image/common/go.png" alt="" />
              返回上一页 -->
              <i class="el-icon-circle-close"></i>
            </div>
            <!-- 返回上一页 end -->

            <!-- banner -->
            <!-- <div class="banner_conter">
              <div class="c_wrap">
                <h1 class="c_carousel">{{item.title}}
                  <span @click.stop="desc_cover = !desc_cover">
                    <img src="@/assets/image/works/go_show.png"
                         :class="desc_cover==true ?'deg':''"
                         alt=""></span>
                </h1>
                <div class="photo_desc"
                     v-show="desc_cover">
                  <el-collapse-transition>
                    <div>
                      <div class="  transition-box fade_image_out"
                           v-if="item.comments">{{item.comments}}</div>
                      <div class="
                   transition-box fade_image_out"
                           v-else>暂无影展简介...</div>
                    </div>
                  </el-collapse-transition>
                </div>
                <div v-if="item.workList">
                  <carousel-3d :autoplay="true"
                               :autoplayTimeout="3000"
                               :controlsViblse="true"
                               :display="5"
                               :width="1000"
                               :height="700"
                               :animationSpeed="1000">
                    <slide class="carousel_box"
                           v-for="(item_son,idx) in item.workList"
                           :key="idx"
                           :index="idx">
                      <div class="carousel_flashlight">
                        <p>{{item_son.idx}}</p>
                        <h3>{{item_son.idx}}</h3>
                        <img :src="item_son.workUrl"
                             alt=""
                             class="fade_image_out">

                        
                        <div class="error_img">
                          <div class="error_img_conter">
                            <img :src="error_login"
                                 alt="">
                          </div>
                        </div>

                      </div>
                    </slide>
                  </carousel-3d>
                </div>
                <div class=""
                     v-if="!item.workList">
                  <img src="@/assets/image/common/null_cover.png"
                       alt="">

                </div>

              </div>

            </div> -->

            <div class="phone_show_item">
              <!-- <p class="albumName">
                {{ item.title }}
                <span @click.stop="desc_cover = !desc_cover" class="look_desc">
                  <i class="el-icon-arrow-down" v-if="desc_cover"></i>
                  <i class="el-icon-arrow-up" v-if="!desc_cover"></i>
                </span>
              </p>
              <div class="photo_desc" v-show="desc_cover">
                <el-collapse-transition>
                  <div>
                    <div
                      class="transition-box fade_image_out"
                      v-if="item.comments"
                    >
                      {{ item.comments }}
                    </div>
                    <div class="transition-box fade_image_out" v-else>
                      暂无影展简介...
                    </div>
                  </div>
                </el-collapse-transition>
              </div> -->
              <div class="photo-top">
                <el-tooltip  placement="bottom" popper-class="photo-brief" :visible-arrow="false">
                  <div slot="content">
                    <div>
                      <div v-if="item.comments">{{ item.comments }}</div>
                      <div v-else> 暂无影展简介...</div>
                    </div>
                  </div>
                  <p class="albumName">{{item.title}}</p>
                </el-tooltip>
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="photo-share"
                  width="120"
                >
                  <div class="share" id="share">
                    <!-- <span>分享到：</span> -->
                    <a href="javascript:;"
                      @click="share_qq"
                      target="_blank"><i class="fa fa-qq"></i>QQ</a>
                    <a href="javascript:;"
                      @click="share_wb"><i class="fa fa-weibo"></i>微博</a>
                    <a href="javascript:;"
                      class="sharewb">
                     <i class="fa fa-weixin"></i>微信
                    </a>
                    <div class="wecodeSp"
                      :id="`qrcodes${index}`"
                      :ref="`qrcodeContainers${index}`"
                    >
                    </div>
                  </div>
                  <p class="share-btn" slot="reference"><i class="el-icon-share"></i></p>
                </el-popover>
              </div>
              <div class="banner_conter">
                <div v-if="item.workList">
                  <carousel-3d
                    ref="slideCarousel"
                    :autoplay="true"
                    :autoplayTimeout="300000"
                    :controlsViblse="true"
                    :controlsVisible="true"
                    controlsPrevHtml="&lsaquo;"
                    controlsNextHtml="&rsaquo;"
                    :controlsWidth="80"
                    :controlsHeight="80"
                    :display="5"
                    :width="1000"
                    :clickable="false"
                    :height="dynamicHeight"
                    :animationSpeed="1000"
                    :onSlideChange="onSlideChange"
                    class="carousel-box"
                    :loop="false"
                  >
                    <slide
                      class="carousel_box"
                      v-for="(item_son, idx) in item.workList"
                      :key="idx"
                      :index="idx"
                    >
                      <template slot-scope="obj">
                        <div class="carousel_flashlight">
                          <p>{{ item_son.idx }}</p>
                          <h3>{{ item_son.idx }}</h3>
                          <img
                            :src="item_son.workUrl"
                            alt=""
                            class="fade_image_out"
                          />
                          <div class="error_img" v-if="!item_son.workUrl">
                            <div class="error_img_conter">
                              <img :src="error_login" alt="" />
                            </div>
                          </div>
                        </div>
                      </template>
                    </slide>
                  </carousel-3d>
                </div>
                <div class="" v-if="!item.workList">
                  <img src="@/assets/image/common/null_cover.png" alt="" />
                </div>
              </div>
              <div class="legend">
                <a
                  class="transition-box fade_image_out"
                  :title="item.workList[showIndex].comments"
                  v-if="item.workList[showIndex].comments"
                  >{{ item.workList[showIndex].comments }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

import { ta_PhotoShow } from "@/utils/api/ucenter.js"; //用户信息
import Loading from "@/components/loading/loading.vue"; //loading
import { Carousel3d, Slide } from "vue-carousel-3d";
import {socialShare, formatDate} from '@/modules/common.js'

export default {
  name: "app",
  data() {
    return {
      photo_data: [], //他人影展作品
      step: 0, //
      desc_cover: false, //展开面板
      defaultImg:
        'this.src="' + require("@/assets/image/common/loading.gif") + '"', //未加载
      error_login: require("@/assets/image/common/loading.gif"),
      showIndex: 0, // 当前显示得轮播图index
      //分享
      share: {},
    };
  },
  filters: {
    filterFun_as: function (value) {
      return value.replace(".jpg", "_as.jpg"); //最大
    },
    filterFun_ss: function (value) {
      return value.replace(".jpg", "_activity_ss.jpg"); //最小
    },
    filterFun_sss: function (value) {
      return value.replace(".jpg", "_activity_sss.jpg"); //最小
    },
  },
  created() {
    let userId = this.$route.query && this.$route.query.userId;
    this.userId = userId;
    let params = {
      userId: this.userId,
    };
    this.other_ta_PhotoShow(params); //用户基本细信息
    // 设置当前为第几个影展
    this.step = this.$route.query && this.$route.query.step || 0;
  },
  computed: {
    dynamicHeight: function() {
      return (window.innerHeight - 180); //自定义高度需求
    }
  },
  methods: {
    // 返回上一层
    back() {
      // this.$router.go(-1); //
      this.$router.push({ path: '/Ucenter/' + this.userId + '?type=2' })

    },
    onSlideChange(index) {
      this.showIndex = index;
    },

    // 影展的列表
    other_ta_PhotoShow(params) {
      this.loading_bool = true;
      ta_PhotoShow(params).then((res) => {
        let data = res.data;
        this.photo_data = data.data; //背景图
        // this.getSocialShareUrls();
        this.$nextTick(() => {
          let query = JSON.parse(JSON.stringify(this.$route.query))
          document.title = '中经视觉-' + this.photo_data[query.step].title
          this.photo_data.map((i, k) => {
            this.showQRCodes('qrcodes'+k);
          })
        })
        this.loading_bool = false;
      });
    },
    // 点击翻页后隐藏上个简介
    on() {
      this.desc_cover = false;
      // 切换影展时当前轮播图index 设为0
      this.showIndex = 0;
      document.title = '中经视觉-' + this.photo_data[this.step].title
      this.changeURLStatic()
    },
    changeURLStatic(name, value) {
      let query = JSON.parse(JSON.stringify(this.$route.query))
      query.step = this.step
      this.$router.push({ path: this.$route.path, query })
    },

    // 显示简介
    desc_cover_click() {
      this.desc_cover = !desc_cover;
    },
    mose_bag_click() {
      this.desc_cover = -1;
    },
     // 生成为二维码
    showQRCodes (id) {
      setTimeout(() => {
        this.url = 'https://v.jingjiribao.cn/newcommunity' +'#' + this.$route.fullPath
        let qrcode = new this.$QRCode(id, {
          text: this.url, //当前地址栏完整参数
          width: 100,
          height: 100,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: this.$QRCode.CorrectLevel.H
        });
      }, 1000);
    },
    //  分享到qq
    share_qq () {
      const share = {
        title: this.photo_data[this.step].title,
        desc: this.photo_data[this.step].comments,
        share_url: window.location.href,
      };
      window.open("https://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(share.share_url) + "&title=" + share.title + "&desc=" + share.desc);
    },

    //  分享到微博
    share_wb () {
      const share = {
        title: this.photo_data[this.step].title,
        desc: this.photo_data[this.step].comments,
        share_url: window.location.href,
      };
      window.open('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');
    },

    // 分享
    getSocialShareUrls () {
      let info = {
        url: this.url,
        title: `中经视觉-${this.photo_data[this.step].title}`,
        source: `中经视觉-${this.photo_data[this.step].title}`,
        desc: `中经视觉-${this.photo_data[this.step].title}`,
        image: `中经视觉-${this.photo_data[this.step].title}`,
        summary: `中经视觉-${this.photo_data[this.step].title}`
      };
      ["qq", "wx", "wb", "kj"].forEach(v => {
        this.share[v] = socialShare(v, info);
      });
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.back)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.back)
  },
  components: {
    Carousel3d,
    Slide,
    Loading,
    CollapseTransition,
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/community/findDetail";
/* 返回上页 */
.go_home {
  position: absolute;
  right: 20px;
  top: 12px;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  color: #c1c1c1;
  height: 30px;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 999999;
}
.go_home img {
  width: 30px;
  height: 30px;
  margin: 0 5px;
}
.bag_cover {
  /* position: relative; */
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;

  display: flex;
  flex-wrap: wrap;
}
.page_center {
  position: relative;
  height: 100%;
}
/* 上按钮 */
.up {
  position: fixed;
  left: 50%;
  top: 0;
}
/* 下按钮 */
.bottom {
  position: fixed;
  left: 50%;
  bottom: 0;
}
.up,
.bottom {
  width: 50px;
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  transform: translate(-50%, 0);
  z-index: 100;
}
.prev-btn,
.next-btn {
  cursor: pointer;
  display: block;
  /* text-align: center;
  width: 20px;
  height: 20px;
  border: 4px solid #fff; */
  background-color: transparent;
  outline: none;
}
.prev-btn {
  top: 80px;
  transform: rotate(0deg);
  border-bottom-color: transparent;
  border-left-color: transparent;
  animation: prev-up-down 1s linear 0s infinite;
}
.next-btn {
  bottom: 80px;
  transform: rotate(0deg);
  border-top-color: transparent;
  border-left-color: transparent;
  animation: next-up-down 1s linear 0s infinite;
}
@keyframes next-up-down {
  0% {
    transform: translate3d(0, 0, 0);
  }
  25% {
    transform: translate3d(0, 6px, 0);
  }
  50% {
    transform: translate3d(0, 0, 0);
  }
  75% {
    transform: translate3d(0, -6px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes prev-up-down {
  0% {
    transform: translate3d(0, 0, 0);
  }
  25% {
    transform: translate3d(0, -6px, 0);
  }
  50% {
    transform: translate3d(0, 0, 0);
  }
  75% {
    transform: translate3d(0, 6px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

.page {
  position: fixed;
  top: 0%;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 10;
  transition: 1s;
  float: left;
}
.page .bag_img {
  width: 100%;
  height: 100%;
  float: left;
  object-fit: cover;
  float: left;
}
.mose_bag {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 21;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.85);
}

/* 兼容火狐*/
@-moz-document url-prefix() {
  .mose_bag {
    background-color: rgba(0, 0, 0, 0.9) !important;
  }
}
.phone_show_item {
  width: 100%;
  height: 100%;
  position: relative;
}
.photo-top {
  position: absolute;
  top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.albumName {
  text-align: center;
  font-size: 18px;
  color: #c1c1c1;
  /* width: 500px; */
  cursor: pointer;
}
.share-btn {
  color: #c1c1c1;
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;

}

.legend {
  text-align: left;
  font-size: 16px;
  color: #fff;
  width: 1000px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  margin-left: -500px;
  max-height: 60px;
}
.legend .transition-box {
  /* white-space: wrap;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis; */
  height: 100%;
  width: 100%;
  color: #c1c1c1;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 00.14rem;
}

.banner_conter {
  width: 100%;
  padding: 0 10%;
  padding: 0 50px;
  /* padding: 0 20px; */
  /* height: 5rem; */
  position: absolute;
  top: 50%;
  left: 50%;
  /* background-color: powderblue; */

  /* backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.75); */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 20;
  transform: translate(-50%, -50%);
}
.banner_conter img {
  height: 1rem;
  width: 1rem;
}

/* 影展标题 */
.c_carousel {
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
}
.c_carousel span {
  cursor: pointer;
}
.c_carousel span img {
  width: 0.15rem;
  height: 100%;
  transition: all 0.3s;
}

.photo_desc {
  text-indent: 2em;
  position: absolute;
  left: 50%;
  top: 95px;
  z-index: 99;
  -webkit-transform: translate(-50%, 0%);
  transform: translate(-50%, 0%);
  border-radius: 5px;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0.2rem 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  width: 30%;
  display: block;
  border: 1px solid #7c7c7a;
  line-height: 0.3rem;
  font-size: 0.14rem;
}
.photo-brief {
  text-indent: 2em;
  border-radius: 5px;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0.2rem 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  width: 30%;
  display: block;
  border: 1px solid #7c7c7a;
  line-height: 0.3rem;
  font-size: 0.14rem;

}
/* 兼容火狐*/
@-moz-document url-prefix() {
  .photo_desc {
    background-color: rgba(0, 0, 0, 0.9) !important;
  }
}

.deg {
  transform: rotate(180deg);
}

/* banner */

.carousel_box {
  width: 100%;
  display: flex;
}
.carousel_flashlight {
  flex: 1;
  height: 100%;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
  /* background: #f2f2f2; */
}
.carousel_flashlight p {
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: #51e8ec;
  line-height: 28px;
}
.carousel_flashlight h3 {
  font-size: 84px;
  font-family: "digital-7";
  text-align: center;
  color: #ffffff;
  line-height: 101px;
}
.zoomImage {
  /* background-size: 1000px 418px; */
  /* width: 100%;
  height: 0;
  padding-top: 100%;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover; */
}
.carousel_flashlight img {
  /* width: 100%; */
  /* width: auto;
  height: 418px; */
  /* max-width: 1000px;
  max-height: 418px; */
  /* float: left; */
  /* object-fit: cover; */
  /* object-fit:contain;
  object-fit:scale-down; */
  height: 100%;
  /* max-width: 100%; */
  width: 100%;
  object-fit: scale-down;
  /* position: absolute; */
  position: relative;
  z-index: 33;
}
/* 覆盖轮播样式 */
.carousel-3d-slide {
  background: none;
  border: 0px;
}
.look_desc {
  cursor: pointer;
  font-size: 20px;
}

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 1s;
// }
// .fade-enter,
// .fade-leave-to {
//   transform: translateX(100px);
//   opacity: 0;
// }
</style>




// WEBPACK FOOTER //
// src/views/community/PhotoShow.vue